import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { ColumnMode } from '@swimlane/ngx-datatable';
import { TransactionService } from 'app/services/models/transaction.service';
import { BlockUI, NgBlockUI } from 'ng-block-ui';

@Component({
  selector: 'app-list-fixtures',
  templateUrl: './list-fixtures.component.html',
  styleUrls: ['./list-fixtures.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ListFixturesComponent implements OnInit {
  public contentHeader;

  @BlockUI('section-block') blockUI: NgBlockUI;
  rows: any;
  public pageBasic = 1;
  public selectedSize = 5;
  public basicSelectedOption: number = 5;
  public searchValue = '';
  totalCount: Number = 0;
  public ColumnMode = ColumnMode;

  constructor(
    private transactionManagementService: TransactionService
  ) { }

  async ngOnInit() {
    this.contentHeader = {
      headerTitle: 'Demirbaş',
      actionButton: true,
      breadcrumb: {
        type: '',
        links: [
          {
            name: 'Demirbaş Listesi',
            isLink: true,
          },
        ]
      }
    };
    await this.getAllOffer(this.pageBasic - 1, this.selectedSize, this.searchValue);
  }

  async getAllOffer(page, size, search) {
    this.blockUI.start('Demirbaşlar yükleniyor...')
    try {
      const data = await this.transactionManagementService.GetTransactionManagementExpenseList(page, size, search);
      this.rows = data.fixtures;

      console.log(this.rows);
      this.totalCount = data.totalCount;
    } catch (error) {
    }
    this.blockUI.stop()
  }

  totalPrice(price: number, taxRate: number, discountRate: number): number {
    // İndirim uygulanmış fiyatı hesapla
    const discountedPrice = price * (1 - discountRate / 100);

    // Vergi eklenmiş toplam fiyatı hesapla
    const total = discountedPrice * (1 + taxRate / 100);

    // Sonucu döndür
    return total;
  }

  
  filterUpdate(event) {
    const val = event.target.value.toLowerCase();
    this.searchValue = val;
    setTimeout(async () => {
      await this.getAllOffer(this.pageBasic - 1, this.selectedSize, this.searchValue);
    }, 500);
  }

  async onPageChange(pageNumber: number) {
    await this.getAllOffer(this.pageBasic - 1, this.selectedSize, this.searchValue);
  }

  async onOptionChange() {
    this.selectedSize = Number(this.basicSelectedOption)
    await this.getAllOffer(this.pageBasic - 1, this.selectedSize, this.searchValue);
  }
}